import { PLATFORM_THEME_COLORS } from '@thinknet-gmbh/platform-common-ui';
import { PayrollAccountingStatusesEnum } from '@thinknet-gmbh/platform-common';

export const PAYROLL_ACCOUNTING_STATUSES_STYLES = {
  [PayrollAccountingStatusesEnum.noCreated]: {
    background: PLATFORM_THEME_COLORS.grayVariations.light,
    fontColor: PLATFORM_THEME_COLORS.grayVariations.dark,
  },
  [PayrollAccountingStatusesEnum.sent]: {
    background: PLATFORM_THEME_COLORS.tone.lightBlue,
    fontColor: PLATFORM_THEME_COLORS.primary.blue,
  },
  [PayrollAccountingStatusesEnum.created]: {
    background: PLATFORM_THEME_COLORS.tone.lightGreen,
    fontColor: PLATFORM_THEME_COLORS.tone.green,
  },
};
